export default "__VITE_ASSET__DmG$3mPU__"